import React from "react";
import { Route } from "react-router-dom";
import routes from "routes/routes";
import {
  getPathToCertificationToBeSignedDetailsOverview,
  getPathToCertificationToBeSignedDetailsSessions,
} from "module/certification/helper/getPath";
import CertificationDetailsNavigation from "module/certification/enrichedComponent/detailsNavigation/CertificationDetailsNavigation";

interface Props {
  certificationId: string;
}

const CertificationToBeSignedDetails: React.FC<Props> = ({
  certificationId,
}) => {
  return (
    <>
      <CertificationDetailsNavigation
        {...{
          listPath: routes.toBeSigned.path,
          overviewPath:
            getPathToCertificationToBeSignedDetailsOverview(certificationId),
          sessionsPath:
            getPathToCertificationToBeSignedDetailsSessions(certificationId),
        }}
      />
      <Route
        {...{
          key: routes.certificationToBeSignedDetailsOverview.path,
          path: routes.certificationToBeSignedDetailsOverview.path,
          render: () => (
            <routes.certificationToBeSignedDetailsOverview.mainComponent />
          ),
        }}
      />
      <Route
        {...{
          key: routes.certificationToBeSignedDetailsSessions.path,
          path: routes.certificationToBeSignedDetailsSessions.path,
          render: () => (
            <routes.certificationToBeSignedDetailsSessions.mainComponent />
          ),
        }}
      />
    </>
  );
};

export default React.memo(CertificationToBeSignedDetails);
